import { ShortCode } from '@highereducation/wordpress';
import { BentoBoxCell } from '@highereducation/hen-ui';

type BentoBoxCellShortcodeProps = {
  'col-span'?: string;
  'row-span'?: string;
  variant?: 'dark' | 'primary' | 'secondary' | 'none';
  /** Omit cell padding for full-bleed media (`none`); default is padded. */
  padding?: 'default' | 'none';
  /** `center` (default) centers copy; `start` for full-bleed image cells. */
  'content-align'?: 'start' | 'center';
  /** WordPress `class` attribute (merged with className). */
  class?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

/**
 * BentoBoxCellShortcode — renders BentoBoxCell inside [hen-ui-bento-box].
 */
export const BentoBoxCellShortcode: ShortCode<BentoBoxCellShortcodeProps> = {
  component: ({
    'col-span': colSpan = '1',
    'row-span': rowSpan = '1',
    variant = 'dark',
    padding = 'default',
    'content-align': contentAlign = 'center',
    class: classFromWp,
    className,
    children,
  }) => {
    const col = (
      ['1', '2', '3', '4'].includes(colSpan) ? parseInt(colSpan, 10) : 1
    ) as 1 | 2 | 3 | 4;
    const row = (
      ['1', '2', '3'].includes(rowSpan) ? parseInt(rowSpan, 10) : 1
    ) as 1 | 2 | 3;

    const variantResolved =
      variant === 'none' ||
      variant === 'dark' ||
      variant === 'primary' ||
      variant === 'secondary'
        ? variant
        : 'dark';

    const mergedClass =
      [classFromWp, className].filter(Boolean).join(' ') || undefined;

    return (
      <BentoBoxCell
        colSpan={col}
        rowSpan={row}
        variant={variantResolved}
        padding={padding === 'none' ? 'none' : 'default'}
        contentAlign={contentAlign === 'start' ? 'start' : 'center'}
        className={mergedClass}
      >
        {children}
      </BentoBoxCell>
    );
  },
};
